import React from 'react';
import { ActivityIcon, MapPinIcon, MessageSquareTextIcon, QrCodeIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { reveal } from '../utils/motion';
const signals = [{
  icon: ActivityIcon,
  label: 'Campaign attention',
  value: '84.2K',
  note: 'people reached'
}, {
  icon: QrCodeIcon,
  label: 'Product trial',
  value: '12.4K',
  note: 'QR redemptions'
}, {
  icon: MessageSquareTextIcon,
  label: 'Consumer signal',
  value: '4.8 / 5',
  note: 'product sentiment'
}, {
  icon: MapPinIcon,
  label: 'Activation learning',
  value: '18',
  note: 'high-response locations'
}];
export function Features() {
  const reduceMotion = useReducedMotion();
  return <section id="signals" className="border-y border-ink/15 bg-paper px-5 py-14 md:px-10" aria-labelledby="signals-heading" data-id="element-391" data-mp="1eazvkfs5rgss">
      <div className="mx-auto max-w-shell" data-id="element-392" data-mp="2u05lqta9e1x">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end" data-id="element-393" data-mp="2rnhsx0ug9gy">
          <div data-id="element-394" data-mp="2xu6ryz0ns62w">
            <p className="text-xs font-extrabold tracking-[0.16em] text-ink/55" data-id="element-395" data-mp="2xvrnoryplv2c">
              EXAMPLE CAMPAIGN SIGNAL
            </p>
            <h2 id="signals-heading" className="mt-3 font-display text-3xl font-bold md:text-5xl" data-id="element-396" data-mp="36v4qj1sbvle3">
              Not more samples. More signals.
            </h2>
          </div>
          <p className="max-w-sm text-sm font-bold leading-relaxed text-ink/60" data-id="element-397" data-mp="3grr91jx6m0cy">
            Illustrative campaign view. Replace with verified campaign data when
            available.
          </p>
        </div>

        <div className="mt-10 grid border-t border-ink/15 md:grid-cols-4" data-id="element-398" data-mp="3qi2n3zakxpxk">
          {signals.map((signal, index) => {
          const Icon = signal.icon;
          return <motion.div key={signal.label} {...reveal(reduceMotion, index)} className="border-b border-ink/15 py-6 md:border-b-0 md:border-r md:px-6 md:last:border-r-0 md:first:pl-0" data-id="element-399" data-mp="3exunhg5msfv" data-mpi={index}>
                <div className="flex items-center gap-2.5 text-sm font-extrabold text-ink/65" data-id="element-400" data-mp="2s4ygupuc2c0i">
                  <Icon size={17} className="text-signal" aria-hidden="true" data-id="element-401" data-mp="2x3i2ep50llsc" />
                  {signal.label}
                </div>
                <p className="mt-6 font-display text-4xl font-bold" data-id="element-402" data-mp="35ypt45zg89zx">
                  {signal.value}
                </p>
                <p className="mt-1.5 text-sm text-ink/60" data-id="element-403" data-mp="3aw7th7zehgwb">{signal.note}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}